import { render } from "./StethoscopeGuidancePopup.vue?vue&type=template&id=61254f66"
import script from "./StethoscopeGuidancePopup.vue?vue&type=script&lang=js"
export * from "./StethoscopeGuidancePopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__